export default function getOriginalSelections(days) {
  let originalRecipes = [];
  let originalProducts = [];

  let daysWithMealsOrProducts = days.filter((day) => day.HasMealsOrProducts && !day.IsDayPastCutOff);

  let daysWithRecipes = daysWithMealsOrProducts.filter((day) => day.Recipes && day.Recipes.length > 0);

  daysWithRecipes.map((day) => {
    day.Meals.map((meal) => {
      day.Recipes.map((recipe) => {
        if (recipe.Quantity > 0 && recipe.ProgramMealId === meal.ProgramMealId) {
          originalRecipes.push({
            mealDate: day.DateFormatted,
            mealId: meal.ProgramMealId,
            recipeId: recipe.RecipeId,
            quantity: recipe.Quantity,
            ingReplacements: JSON.stringify(recipe.Assignments.map(a => a.SelectedIngredientOptions)),
          });
        }
      });
    });
  });

  daysWithMealsOrProducts.map((day) => {
    day.Products.map((product) => {
      if (product.PurchasedQuantity > 0) {
        originalProducts.push({
          mealDate: day.DateFormatted,
          productId: product.ProductId,
          purchasedQuantity: product.PurchasedQuantity,
          newQuantity: product.NewQuantity,
        });
      }
    });
  });

  return {
    originalRecipes,
    originalProducts,
  };
}
